module.exports = __webpack_public_path__ + "img/earth-asia.d8ef001b.svg";